import { useAttributesContext } from "shared/contexts/AttributesContext";
import { ContextProviderName } from "shared/contexts/types";
import { CUSTOM_RECORDS_GENERIC_FILTER } from "shared/filterDefinitions";

import { SchemaEntry } from "features/ui/MaterialTable";

import useDealersSchema from "./dealerSchema";
import { SchemaRelations, UseSchema } from "./types";
import {
  getAttributeMap,
  getDisplayLabelFunction,
  getFilterFunction,
  getSchemaEntryFunction,
  getSchemaForAccessorFunction,
  getSchemaFromAttributes,
} from "./utils/schema-utils";

export const useCustomRecordsSchema = (
  accessorsToHide: string[] = []
): UseSchema => {
  const { attributes } = useAttributesContext(ContextProviderName.CustomRecord);

  const dealerSchema = useDealersSchema();

  const attributeMap = getAttributeMap(attributes);

  const getDisplayLabel = getDisplayLabelFunction(attributeMap);

  const getFilter = getFilterFunction(
    CUSTOM_RECORDS_GENERIC_FILTER,
    attributeMap
  );

  const getSchemaEntry = getSchemaEntryFunction(getFilter, attributeMap);

  const relations: SchemaRelations = {
    "/api/v1/dealers": dealerSchema,
  };

  const schema: SchemaEntry[] = getSchemaFromAttributes(
    attributes,
    getSchemaEntry,
    undefined,
    relations,
    accessorsToHide
  );

  const getSchemaForAccessor = getSchemaForAccessorFunction(schema);

  return {
    schema,
    attributes,
    getDisplayLabel,
    attributeMap,
    attributeAccessors: schema.map(
      ({ accessor, filter }) => filter?.fieldName || accessor
    ),
    getSchemaEntry,
    getSchemaForAccessor,
  };
};
